import React from "react";
import { Doughnut } from "react-chartjs-2";
import _ from "lodash";
import { doughnutOptions } from "./_commonSharedChartOptions";
import { setColor } from "../../../../views/Dashboard/dashboard/ColorPalette";
import { connect } from "react-redux";
import { WidgetNoDataToDisplay, WidgetServerError } from "../../../../components/DashboardWidget/WidgetCommon";
import { lexPlatformUsageDataPreview } from "./_previewData";
import "chartjs-plugin-datalabels";

const config_default = {
  Chart: "LEX_PLATFORM_USAGE",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

class LexPlatformUsageContentClass extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { widgetData, draggable } = this.props;
    return (
      <div>
        <div className="widgetTitle">Website/Mobile Platform Usage</div>
        <div className="widgetBody">
          {draggable ? (
            <WidgetServerError draggable={draggable} />
          ) : widgetData === undefined || draggable ? (
            <WidgetNoDataToDisplay draggable={draggable} />
          ) : (
            <Doughnut
              id="LEX_PLATFORM_USAGE"
              data={{
                labels: this.props.widgetData.labels,
                datasets: [
                  {
                    data: this.props.widgetData.data,
                    backgroundColor: setColor(this.props.widgetData.labels)
                  }
                ]
              }}
              options={_.merge({}, doughnutOptions, {
                legend: { position: "right" }
              })}
            />
          )}
        </div>
      </div>
    );
  }
}

export class LexPlatformUsagePreview extends React.Component {
  render() {
    return (
      <div>
        <div className="widgetTitle">Website/Mobile Platform Usage</div>
        <div className="widgetBody">
          <Doughnut
            id="LEX_PLATFORM_USAGE"
            data={lexPlatformUsageDataPreview}
            options={_.merge({}, doughnutOptions, {
              legend: {
                position: "right",
                labels: {
                  fontSize: 8
                }
              },
              plugins: {
                datalabels: {
                  font: {
                    size: 7
                  }
                }
              }
            })}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    widgetData: state.dashboard.data["RequestsPerPlatform"]
  };
}

export const LexPlatformUsageContent = connect(
  mapStateToProps,
  undefined
)(LexPlatformUsageContentClass);
